import { Loader } from '@seen/react'
import { type JSX, lazy, Suspense } from 'react'

// Admin-only route (/organizations/:organizationId), reached by explicit
// navigation. App.tsx's <Outlet /> already supplies Suspense + an
// ErrorBoundary; the local Suspense keeps this safe if mounted without one.
const OrganizationDetailPageImpl = lazy(() =>
  import('#src/pages/organizations/OrganizationDetailPageImpl.tsx').then(
    (m) => ({ default: m.OrganizationDetailPageImpl })
  )
)

export function OrganizationDetailPage(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <OrganizationDetailPageImpl />
    </Suspense>
  )
}
